import {Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {RecommendationManagerSharedDataService} from '../recommendation-manager-shared-data.service';
import {data} from 'autoprefixer';
import {Subscription} from 'rxjs';

@Component({
    selector: 'app-leaf-recommendation',
    templateUrl: './leaf-recommendation.component.html',
    styleUrls: ['./leaf-recommendation.component.css'],
    standalone: false
})
export class LeafRecommendationComponent implements OnInit, OnDestroy {

  sampleSource: MatTableDataSource<any> = null;
  recommendationDetails: any = null;
  subscriptions: Subscription[] = [];
  pageSize: number = 20;
  currentPage: number = 0;
  totalElements: number = 0;
  searchText: string = '';
  showNorm: boolean = true;
  @Input() note: string = '';
  @Input() comment: string = '';
  @Output() noteChangeEmit = new EventEmitter();
  @Output() emitPaginateChange = new EventEmitter();
  @Output() emitSearch = new EventEmitter();

  nValues: any[] = [];
  pValues: any[] = [];
  kValues: any[] = [];
    caValues: any[] = [];
    mgValues: any[] = [];
    naValues: any[] = [];
    sValues: any[] = [];
    clValues: any[] = [];
    cuValues: any[] = [];
    znValues: any[] = [];
    mnValues: any[] = [];
    bValues: any[] = [];
    feValues: any[] = [];
    moValues: any[] = [];
  sampleColumns = [
      'farm',
      'field',
      'sample',
      'sampleDate',
      'labReference',
      'labDate',
      'crop',
      'region',
      'growthStage',
      'cultivar',
      'blank',
      'nitrogen',
      'phosphorus',
      'potassium',
      'calcium',
      'magnesium',
      'sodium',
      'sulfur',
      // 'chlorine',
      'copper',
      'zinc',
      'manganese',
      'boron',
      'iron',
      'molybdenum'
  ];

  constructor(
      private recommendationManagerSharedDataService: RecommendationManagerSharedDataService
  ) {
      this.subscriptions = [
          this.recommendationManagerSharedDataService.recommendationDetailSubject.subscribe({
              next: res => {
                  this.recommendationDetails = res;
                  this.note = this.recommendationDetails?.recommendationNote;
                  this.comment = this.recommendationDetails?.comments;
              }
          }),
          this.recommendationManagerSharedDataService.recommendationSoftTissueSubject.subscribe({
              next: res => {
                  if(res?.content) {
                      this.sampleSource = new MatTableDataSource(res.content);
                      this.totalElements = res.totalElements;
                      this.naValues = [];
                      this.nValues = [];
                      this.pValues = [];
                      this.mnValues = [];
                      this.moValues = [];
                      this.znValues = [];
                      this.bValues = [];
                      this.cuValues = [];
                      this.sValues = [];
                      this.feValues = [];
                      this.clValues = [];
                      this.caValues = [];
                      this.mgValues = [];
                      this.kValues = [];

                      let rowCount = 0;

                      for(let row of res?.content) {
                          if(row?.keyValues?.length > 0) {
                              for(let value of row.keyValues) {
                                  if(value?.key === 'N') {
                                      this.nValues.push(value)
                                  } else if(value?.key === 'P') {
                                      this.pValues.push(value)
                                  } else if(value?.key === 'Mo') {
                                      this.moValues.push(value)
                                  } else if(value?.key === 'Fe') {
                                      this.feValues.push(value)
                                  } else if(value?.key === 'B') {
                                      this.bValues.push(value)
                                  } else if(value?.key === 'Mn') {
                                      this.mnValues.push(value)
                                  } else if(value?.key === 'Zn') {
                                      this.znValues.push(value)
                                  } else if(value?.key === 'Cu') {
                                      this.cuValues.push(value)
                                  } else if(value?.key === 'Cl') {
                                      this.clValues.push(value)
                                  } else if(value?.key === 'S') {
                                      this.sValues.push(value)
                                  } else if(value?.key === 'Na') {
                                      this.naValues.push(value)
                                  } else if(value?.key === 'Mg') {
                                      this.mgValues.push(value)
                                  } else if(value?.key === 'Ca') {
                                      this.caValues.push(value)
                                  }else if(value?.key === 'K') {
                                      this.kValues.push(value)
                                  }
                              }

                              this.checkValues(++rowCount);

                          }
                      }
                  }
              }
          })
      ]
  }

  checkValues(rowCount: number) {
    if(this.nValues.length !== rowCount) {
        this.nValues.push({});
    }

    if(this.pValues.length !== rowCount) {
        this.pValues.push({});
    }

    if(this.moValues.length !== rowCount) {
        this.moValues.push({});
    }

    if(this.feValues.length !== rowCount) {
        this.feValues.push({});
    }

    if(this.bValues.length !== rowCount) {
        this.bValues.push({});
    }

    if(this.mnValues.length !== rowCount) {
        this.mnValues.push({});
    }

    if(this.znValues.length !== rowCount) {
        this.znValues.push({});
    }

    if(this.cuValues.length !== rowCount) {
        this.cuValues.push({});
    }

    if(this.clValues.length !== rowCount) {
        this.clValues.push({});
    }
    
    if(this.sValues.length !== rowCount) {
        this.sValues.push({});
    }

    if(this.naValues.length !== rowCount) {
        this.naValues.push({});
    }

    if(this.mgValues.length !== rowCount) {
        this.mgValues.push({});
    }

    if(this.caValues.length !== rowCount) {
        this.caValues.push({});
    }

    if(this.kValues.length !== rowCount) {
        this.kValues.push({});
    }
  }

  emitChanges() {
      this.noteChangeEmit.emit({
          comment: this.comment,
          note: this.note
      });
  }

  ngOnInit() {

  }

  emitSearchChanges() {
      this.emitSearch.emit(this.searchText);
  }

    onPaginateChange(event: any) {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.emitPaginateChange.emit(event);
    }

    ngOnDestroy(): void {
      this.subscriptions.forEach(s => {
          s.unsubscribe();
      })
    }
}
